export default "__VITE_PUBLIC_ASSET__cba42415__"